webpackJsonp([0,2],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */
/* exports provided: app, router, store */
/* exports used: app */
/*!***********************!*\
  !*** ./client/app.js ***!
  \***********************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(/*! vue */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex_router_sync__ = __webpack_require__(/*! vuex-router-sync */ 49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_App__ = __webpack_require__(/*! ./components/App */ 35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(/*! ./router */ 17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(/*! ./store */ 18);
/* unused harmony reexport router */
/* unused harmony reexport store */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return app; });






__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */]);

var app = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */](Object.assign({
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */]
}, __WEBPACK_IMPORTED_MODULE_2__components_App___default.a));



/***/ }),
/* 9 */
/* unknown exports provided */
/*!************************************!*\
  !*** ./client/promise-polyfill.js ***!
  \************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_promise_polyfill__ = __webpack_require__(/*! promise-polyfill */ 33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_promise_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_promise_polyfill__);


window.Promise = window.Promise || __WEBPACK_IMPORTED_MODULE_0_promise_polyfill___default.a;

/***/ }),
/* 10 */
/* unknown exports provided */
/* all exports used */
/*!***********************!*\
  !*** ./client/pwa.js ***!
  \***********************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_offline_plugin_runtime__ = __webpack_require__(/*! offline-plugin/runtime */ 32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_offline_plugin_runtime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_offline_plugin_runtime__);


__WEBPACK_IMPORTED_MODULE_0_offline_plugin_runtime___default.a.install({
  // When an update is ready, tell ServiceWorker to take control immediately:
  onUpdateReady: function onUpdateReady() {
    console.log('update ready');
    __WEBPACK_IMPORTED_MODULE_0_offline_plugin_runtime___default.a.applyUpdate();
  },


  // Reload to get the new version:
  onUpdated: function onUpdated() {
    console.log('updated');
    location.reload();
  }
});

/***/ }),
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */
/* exports provided: firestore, default */
/* exports used: firestore */
/*!****************************!*\
  !*** ./client/firebase.js ***!
  \****************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_app__ = __webpack_require__(/*! firebase/app */ 30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_firestore__ = __webpack_require__(/*! firebase/firestore */ 31);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return firestore; });



var config = {
  apiKey: 'AIzaSyCGWUYcFI_8-dosNXZeSk8CETdnI7W0lSk',
  authDomain: 'backend-engineering-website.firebaseapp.com',
  databaseURL: 'https://backend-engineering-website.firebaseio.com',
  projectId: 'backend-engineering-website',
  storageBucket: '',
  messagingSenderId: '593877124444'
};

__WEBPACK_IMPORTED_MODULE_0_firebase_app___default.a.initializeApp(config);

var firestore = __WEBPACK_IMPORTED_MODULE_0_firebase_app___default.a.firestore();

firestore.settings({
  timestampsInSnapshots: true
});

/* unused harmony default export */ var _unused_webpack_default_export = __WEBPACK_IMPORTED_MODULE_0_firebase_app___default.a;

/***/ }),
/* 17 */
/* exports provided: default */
/* exports used: default */
/*!********************************!*\
  !*** ./client/router/index.js ***!
  \********************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(/*! vue */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(/*! vue-router */ 47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_Home__ = __webpack_require__(/*! ../views/Home */ 40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__views_Home__);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'hash',
  routes: [{
    path: '/',
    component: __WEBPACK_IMPORTED_MODULE_2__views_Home___default.a
  }]
});

/***/ }),
/* 18 */
/* exports provided: default */
/* exports used: default */
/*!*******************************!*\
  !*** ./client/store/index.js ***!
  \*******************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(/*! vue */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(/*! vuex */ 7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__firebase__ = __webpack_require__(/*! ../firebase */ 16);




var freelanceRequests = __WEBPACK_IMPORTED_MODULE_2__firebase__["a" /* firestore */].collection('freelanceRequests');

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* default */]);

var state = {
  contacted: false
};

var mutations = {
  SET_CONTACTED: function SET_CONTACTED(contacted) {
    state.contacted = contacted;
  }
};

var actions = {
  submitContactForm: function submitContactForm(_ref, _ref2) {
    var commit = _ref.commit;
    var email = _ref2.email;

    freelanceRequests.doc().set({ email: email, sent: new Date() }).then(function () {
      return commit('SET_CONTACTED', true);
    });
  }
};

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* default */].Store({
  state: state,
  mutations: mutations,
  actions: actions
});

/* harmony default export */ __webpack_exports__["a"] = store;

/***/ }),
/* 19 */
/* exports provided: default */
/* all exports used */
/*!*****************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/Freelance.vue ***!
  \*****************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(/*! vuex */ 7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__GlossyButton__ = __webpack_require__(/*! ./GlossyButton */ 37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__GlossyButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__GlossyButton__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      email: ''
    };
  },
  computed: Object.assign({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["a" /* mapState */])({
    contactFormSubmitted: function contactFormSubmitted(state) {
      return state.contacted;
    }
  })),
  methods: {
    isValidEmail: function isValidEmail(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },
    submitContactForm: function submitContactForm(email) {
      if (!this.contactFormSubmitted && this.isValidEmail(email)) {
        this.$store.dispatch('submitContactForm', { email: email });
      }
    }
  },
  components: {
    GlossyButton: __WEBPACK_IMPORTED_MODULE_1__GlossyButton___default.a
  }
};

/***/ }),
/* 20 */
/* exports provided: default */
/* all exports used */
/*!********************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/GlossyButton.vue ***!
  \********************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = {
  props: {
    color: String,
    componentType: String
  }
};

/***/ }),
/* 21 */
/* exports provided: default */
/* all exports used */
/*!*****************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/HeaderGif.vue ***!
  \*****************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__static_paul_oostenrijk_gif__ = __webpack_require__(/*! ../../static/paul-oostenrijk.gif */ 29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__static_paul_oostenrijk_gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__static_paul_oostenrijk_gif__);
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      image: __WEBPACK_IMPORTED_MODULE_0__static_paul_oostenrijk_gif___default.a
    };
  }
};

/***/ }),
/* 22 */
/* exports provided: default */
/* all exports used */
/*!**************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/Resume.vue ***!
  \**************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var resume = [{
  "company": "Fueled",
  "title": "Director of backend & blockchain",
  "started": "2015",
  "ended": "Present",
  "description": "\n      <ul>\n        <li>Leading a team of backend engineers and smart contract developers</li>\n        <li>Architecting and strategizing application infrastructure with clients</li>\n        <li>Providing reccomendations through Application Designs around code organization and service deployment</li>\n        <li>Building applications in Python and Nodejs, inside the team created experimentations with Elixir and Golang</li>\n        <li>Highly involved in development of the frontend web team and setting standards inside the team</li>\n        <li>Great experience in working with financial systems in the Fintech industry</li>\n        <li>Worked heavily with third party integrations such as Stripe, Twilio, Facebook, Twitter and many more</li>\n        <li>Experience in messaging protocols; Http(s), Websockets, SOAP and Redis PubSub</li>\n        <li>Co created infrastructure and deployment scripts with Terraform and Ansible for setting up new infrastructure quickly </li>\n        <li>Most familiar with AWS services, besides that also experience in working with Heroku, Netlify and Firebase</li>\n        <li>Recently blockchain was introduced as a new service, with my years of experience in the space took up the responsibility for internal research and building a new team</li>\n      </ul>\n    ",
  "companyDescription": "Award winning product agency"
}, {
  "title": "Backend Engineer",
  "started": "2014",
  "ended": "2015",
  "description": "\n      <ul>\n        <li>Moved from frontend to backend engineer as there was a big need, used my previous PHP experience and started to learn Python & NodeJS</li>\n        <li>Worked on projects across many fields and types of integration, most significant working on projects like Matador and Youhue</li>\n        <li>Contributed to internal standards, creating new processes to optimize client project flow</li>\n        <li>Communicated with clients on project to deliver status updates and advice</li>\n      </ul>\n    "
}, {
  "company": "Glem",
  "title": "Co Founder & CTO",
  "companyDescription": "Software for small busisness owners",
  "started": "2015",
  "ended": "Present",
  "description": "\n      <ul>\n        <li>Created a suite of payment & reservation systems for small businesses</li>\n        <li>The systems handles mostly escrow payments between provider and customer, according to their reservations</li>\n        <li>Building out frontend applications for multiple niches around barbershops, workshop owners and jumping halls in the Dutch market</li>\n        <li>Mostly worked with Python for payment backend, all other niche \"backends\" are powered by Firebase for better collaboration with frontend team</li>\n      </ul>\n    "
}, {
  "company": "Glemma",
  "title": "Co Founder",
  "started": "2010",
  "ended": "2015",
  "companyDescription": "Small agency for web development",
  "description": "\n      <ul>\n        <li>Started agency with a good friend of mine in college</li>\n        <li>Building pre-wordpress-era CMS websites with our own CMS called Kiddo, written in PHP</li>\n        <li>Created DBAL, ORM and templating functionality for integrating custom modules for clients</li>\n        <li>Project examples are http://ecnc.org, http://deblikkenemmer.nl, http://eoibisolatie.nl and http://ventilatieland.nl </li>\n        <li>Glemma taught me to work with Magento, CodeIgniter, Zend Framework, Laravel and Wordpress</li>\n        <li>Great demand created demand for freelancers to join organization, we hired several companies for maintenance and development</li>\n        <li>Worked on-site for more specific software development such as Real Estate Management software and a FIFA World Cup Poll Tournament application</li>\n\n      </ul>\n    "
}, {
  "company": "Sendcloud",
  "title": "Co founder & CTO",
  "started": "2011",
  "ended": "2013",
  "description": "\n      <ul>\n        <li>Created the whole application from the start, mostly working individually</li>\n        <li>Increased my PHP and CodeIgniter knowledge</li>\n        <li>Built out both backend and frontend applications, touching the whole spectrum of the project development</li>\n        <li>Created packing slip module integrations in Magento, Woocommerce, Prestashop and Shopify</li>\n        <li>Integrated Python driven hardware for printing out shipping labels</li>\n        <li>Working together with developers overseas</li>\n        <li>Left due to persisting urge to work overseas, company is now worth over 5 million euros (#shamelessplug)</li>\n      </ul>\n    ",
  "companyDescription": "Award winning product agency"
}];

/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      resume: resume
    };
  }
};

/***/ }),
/* 23 */
/* exports provided: default */
/* all exports used */
/*!*******************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/views/Home.vue ***!
  \*******************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_HeaderGif__ = __webpack_require__(/*! components/HeaderGif */ 38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_HeaderGif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_components_HeaderGif__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Resume__ = __webpack_require__(/*! components/Resume */ 39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Resume___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_components_Resume__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Freelance__ = __webpack_require__(/*! components/Freelance */ 36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Freelance___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_Freelance__);
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    HeaderGif: __WEBPACK_IMPORTED_MODULE_0_components_HeaderGif___default.a,
    Resume: __WEBPACK_IMPORTED_MODULE_1_components_Resume___default.a,
    Freelance: __WEBPACK_IMPORTED_MODULE_2_components_Freelance___default.a
  }
};

/***/ }),
/* 24 */
/* unknown exports provided */
/* all exports used */
/*!*****************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?sourceMap&-autoprefixer!./~/vue-loader/lib/style-compiler?{"id":"data-v-1baeefe6","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/Freelance.vue ***!
  \*****************************************************************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 25 */
/* unknown exports provided */
/* all exports used */
/*!*****************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?sourceMap&-autoprefixer!./~/vue-loader/lib/style-compiler?{"id":"data-v-2020710e","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/HeaderGif.vue ***!
  \*****************************************************************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 26 */
/* unknown exports provided */
/* all exports used */
/*!********************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?sourceMap&-autoprefixer!./~/vue-loader/lib/style-compiler?{"id":"data-v-4b178b7a","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/GlossyButton.vue ***!
  \********************************************************************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 27 */
/* unknown exports provided */
/* all exports used */
/*!**************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?sourceMap&-autoprefixer!./~/vue-loader/lib/style-compiler?{"id":"data-v-8f309eb4","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/Resume.vue ***!
  \**************************************************************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 28 */
/* unknown exports provided */
/* all exports used */
/*!***********************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?sourceMap&-autoprefixer!./~/vue-loader/lib/style-compiler?{"id":"data-v-9d6d3910","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/App.vue ***!
  \***********************************************************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 29 */
/* unknown exports provided */
/* exports used: default */
/*!************************************!*\
  !*** ./static/paul-oostenrijk.gif ***!
  \************************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/paul-oostenrijk.4ca92ab8.gif";

/***/ }),
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */
/* unknown exports provided */
/* exports used: default */
/*!***********************************!*\
  !*** ./client/components/App.vue ***!
  \***********************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !../../~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?sourceMap&-autoprefixer!../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-9d6d3910","scoped":false,"hasInlineConfig":false}!../../~/vue-loader/lib/selector?type=styles&index=0!./App.vue */ 28)

var Component = __webpack_require__(/*! ../../~/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  null,
  /* template */
  __webpack_require__(/*! !../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-9d6d3910"}!../../~/vue-loader/lib/selector?type=template&index=0!./App.vue */ 46),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 36 */
/* unknown exports provided */
/* exports used: default */
/*!*****************************************!*\
  !*** ./client/components/Freelance.vue ***!
  \*****************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !../../~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?sourceMap&-autoprefixer!../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-1baeefe6","scoped":false,"hasInlineConfig":false}!../../~/vue-loader/lib/selector?type=styles&index=0!./Freelance.vue */ 24)

var Component = __webpack_require__(/*! ../../~/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../~/vue-loader/lib/selector?type=script&index=0!./Freelance.vue */ 19),
  /* template */
  __webpack_require__(/*! !../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-1baeefe6"}!../../~/vue-loader/lib/selector?type=template&index=0!./Freelance.vue */ 41),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 37 */
/* unknown exports provided */
/* exports used: default */
/*!********************************************!*\
  !*** ./client/components/GlossyButton.vue ***!
  \********************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !../../~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?sourceMap&-autoprefixer!../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-4b178b7a","scoped":false,"hasInlineConfig":false}!../../~/vue-loader/lib/selector?type=styles&index=0!./GlossyButton.vue */ 26)

var Component = __webpack_require__(/*! ../../~/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../~/vue-loader/lib/selector?type=script&index=0!./GlossyButton.vue */ 20),
  /* template */
  __webpack_require__(/*! !../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-4b178b7a"}!../../~/vue-loader/lib/selector?type=template&index=0!./GlossyButton.vue */ 43),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 38 */
/* unknown exports provided */
/* exports used: default */
/*!*****************************************!*\
  !*** ./client/components/HeaderGif.vue ***!
  \*****************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !../../~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?sourceMap&-autoprefixer!../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-2020710e","scoped":false,"hasInlineConfig":false}!../../~/vue-loader/lib/selector?type=styles&index=0!./HeaderGif.vue */ 25)

var Component = __webpack_require__(/*! ../../~/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../~/vue-loader/lib/selector?type=script&index=0!./HeaderGif.vue */ 21),
  /* template */
  __webpack_require__(/*! !../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-2020710e"}!../../~/vue-loader/lib/selector?type=template&index=0!./HeaderGif.vue */ 42),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 39 */
/* unknown exports provided */
/* exports used: default */
/*!**************************************!*\
  !*** ./client/components/Resume.vue ***!
  \**************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !../../~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?sourceMap&-autoprefixer!../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-8f309eb4","scoped":false,"hasInlineConfig":false}!../../~/vue-loader/lib/selector?type=styles&index=0!./Resume.vue */ 27)

var Component = __webpack_require__(/*! ../../~/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../~/vue-loader/lib/selector?type=script&index=0!./Resume.vue */ 22),
  /* template */
  __webpack_require__(/*! !../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-8f309eb4"}!../../~/vue-loader/lib/selector?type=template&index=0!./Resume.vue */ 45),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 40 */
/* unknown exports provided */
/* exports used: default */
/*!*******************************!*\
  !*** ./client/views/Home.vue ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../~/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../~/vue-loader/lib/selector?type=script&index=0!./Home.vue */ 23),
  /* template */
  __webpack_require__(/*! !../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-7bfd4020"}!../../~/vue-loader/lib/selector?type=template&index=0!./Home.vue */ 44),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 41 */
/* unknown exports provided */
/* all exports used */
/*!************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-1baeefe6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/Freelance.vue ***!
  \************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "freelance-container"
  }, [_c('span', {
    staticClass: "freelance-heading"
  }, [_vm._v("Available 4 projects")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.contactFormSubmitted),
      expression: "!contactFormSubmitted"
    }]
  }, [_vm._v("\n    Seeing some collaboration potential? Let me know if you have any projects in mind.\n  ")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.contactFormSubmitted),
      expression: "contactFormSubmitted"
    }]
  }, [_vm._v("\n    Thank you for your inquiry, I will get back to you as soon as I can.\n  ")]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submitContactForm(_vm.email)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    class: {
      'blinker': _vm.email == ''
    },
    attrs: {
      "required": "",
      "type": "email",
      "placeholder": "Email address"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('glossy-button', {
    staticClass: "glossy-button",
    class: _vm.isValidEmail(_vm.email) && !_vm.contactFormSubmitted ? 'purple' : null,
    attrs: {
      "disabled": !_vm.isValidEmail(_vm.email) || _vm.contactFormSubmitted
    }
  }, [_vm._v("\n        " + _vm._s((!_vm.contactFormSubmitted) ? '📨' : '📫') + "\n      ")])], 1)])
},staticRenderFns: []}

/***/ }),
/* 42 */
/* unknown exports provided */
/* all exports used */
/*!************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-2020710e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/HeaderGif.vue ***!
  \************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "img-container"
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.image
    }
  }), _vm._v(" "), _c('h2', [_vm._v("Software Architect specializing in Backend & Blockchain engineering")])])
},staticRenderFns: []}

/***/ }),
/* 43 */
/* unknown exports provided */
/* all exports used */
/*!***************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-4b178b7a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/GlossyButton.vue ***!
  \***************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c(_vm.componentType || 'button', {
    tag: "component",
    staticClass: "glossy-button",
    class: [_vm.color]
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 44 */
/* unknown exports provided */
/* all exports used */
/*!**************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-7bfd4020"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/views/Home.vue ***!
  \**************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page"
  }, [_c('header-gif'), _vm._v(" "), _c('resume'), _vm._v(" "), _c('freelance')], 1)
},staticRenderFns: []}

/***/ }),
/* 45 */
/* unknown exports provided */
/* all exports used */
/*!*********************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-8f309eb4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/Resume.vue ***!
  \*********************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "resume-container"
  }, _vm._l((_vm.resume), function(item) {
    return _c('div', {
      staticClass: "resume-item"
    }, [_c('h3', [_vm._v("\n      " + _vm._s(item.title) + "\n      "), _c('span', {
      staticClass: "period"
    }, [_vm._v("\n        " + _vm._s(item.started) + " - " + _vm._s(item.ended) + "\n      ")])]), _vm._v(" "), _c('h4', [_vm._v("\n      " + _vm._s(item.company) + "\n      "), _c('span', [_vm._v("\n        " + _vm._s(item.companyDescription) + "\n      ")])]), _vm._v(" "), _c('p', {
      domProps: {
        "innerHTML": _vm._s(item.description)
      }
    })])
  }))
},staticRenderFns: []}

/***/ }),
/* 46 */
/* unknown exports provided */
/* all exports used */
/*!******************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-9d6d3910"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/App.vue ***!
  \******************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */
/* unknown exports provided */
/* all exports used */
/*!*************************!*\
  !*** ./client/index.js ***!
  \*************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__promise_polyfill__ = __webpack_require__(/*! ./promise-polyfill */ 9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app__ = __webpack_require__(/*! ./app */ 8);



// Enable progressive web app support (with offline-plugin)
if (true) {
  __webpack_require__(/*! ./pwa */ 10);
}

__WEBPACK_IMPORTED_MODULE_1__app__["a" /* app */].$mount('#app');

/***/ })
],[51]);


// WEBPACK FOOTER //
// client.5171fd12.js